import React from 'react'

import FirstSection from '../Programs//FirstSection'
import SecondSection from '../Programs/SecondSection'

import ColorPallet from '../../../utils/ColorPallet' 

function MainSection() {
  return (
    <div className="min-h-screen">
      {/* First Section */}
        <FirstSection />
      
      {/* Second Section */}
        <div style={{ backgroundColor: ColorPallet.primaryLightBrown }}>
        <SecondSection />
      </div>
      
    </div>
  )
}

export default MainSection